import { createAction } from "@reduxjs/toolkit";
import { typePagination, typeRequestPagination } from "../system/constants";
import { typeAddEdmProductsItemObject } from "../../components/containers/dashboard/dataEdmProducts/popupContents/popupAdd";
import { typeEditEdmProductsItemObject } from "../../components/containers/dashboard/dataEdmProducts/popupContents/popupEdit";
import {
  typeProductsFilters,
  IdProductsStateDataItem,
} from "./dEdmProductsReducer";

const prefix = "D_EDM_PRODUCTS";

/**
 * Action creator of set data
 */
export const dEdmProductsSetDataAC = createAction(
  `${prefix}_SET_DATA`,
  (dataList: IdProductsStateDataItem[]) => ({ payload: { dataList } }),
);

/**
 * Action creator of set pagination
 */
export const dEdmProductsSetPaginationAC = createAction(
  `${prefix}_SET_PAGINATION`,
  (pagination: typePagination) => ({ payload: { pagination } }),
);

/**
 * Action creator of set itemsForPage in pagination
 */
export const dEdmProductsSetItemsForPageAC = createAction(
  `${prefix}_SET_ITEMS_FOR_PAGE`,
  (itemsForPage: number) => ({ payload: { itemsForPage } }),
);

/**
 * Action creator of set pageNumber in pagination
 */
export const dEdmProductsSetPageNumberAC = createAction(
  `${prefix}_SET_PAGE_NUMBER`,
  (pageNumber: number) => ({ payload: { pageNumber } }),
);

/**
 * Action creator of saga set data
 */
export const dEdmProductsSetDataSagaAC = createAction(
  `${prefix}_SET_DATA_SAGA`,
  (
    filters: typeProductsFilters,
    paginationRequest: typeRequestPagination,
    primaryTenant: string,
  ) => ({
    payload: { filters, paginationRequest, primaryTenant },
  }),
);

/**
 * Action creator of set item data
 */
export const dEdmProductsSetDetailItemAC = createAction(
  `${prefix}_SET_DETAIL_ITEM`,
  (detailItemId: string | undefined) => ({ payload: detailItemId }),
);

/**
 * Action creator of clear filtersForm
 */
export const dEdmProductsClearFiltersAC = createAction(
  `${prefix}_CLEAR_FILTERS`,
);

/**
 * Action creator of set filtersForm
 */
export const dEdmProductsSetFiltersAC = createAction(
  `${prefix}_SET_FILTERS`,
  (filtersObject: typeProductsFilters) => ({ payload: filtersObject }),
);

/**
 * Action creator of add item
 */
export const dEdmProductsAddItemSagaAC = createAction(
  `${prefix}_ADD_ITEM_SAGA`,
  (
    itemObject: typeAddEdmProductsItemObject,
    requestData?: {
      primaryTenant: string;
      filters: typeProductsFilters;
      paginationRequest: typeRequestPagination;
    },
  ) => ({
    payload: {
      itemObject,
      requestData,
    },
  }),
);

export const dEdmProductsEditItemSagaAC = createAction(
  `${prefix}_EDIT_ITEM_SAGA`,
  (
    itemObject: typeEditEdmProductsItemObject,
    requestData?: {
      primaryTenant: string;
      filters: typeProductsFilters;
      paginationRequest: typeRequestPagination;
    },
  ) => ({
    payload: {
      itemObject,
      requestData,
    },
  }),
);
